import $ from 'jquery';
import {querySearch} from '../api/api';
import _ from 'underscore';

export default class SearchList {
	constructor(options) {
		const defaults = {
			el: '.js-search-list',
			dom: {
				searchListResults: '.js-search-list-results',
				searchItem: '.js-search-item',
				listCount: '.js-list-count',
				showMore: '.js-show-more',
				aside: '.js-aside',
				searchQueryField: '.js-search-query-field'
			},
			classes: {
				aside: {
					nav: {
						state: {
							opened: 'aside__wrap-aside_state_opened'
						}
					},
					link: {
						state: {
							active: 'aside__link_state_active'
						}
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		const mustacheStyleSyntax = {
			evaluate: /\{\{(.+?)\}\}/g,
			interpolate: /\{\{=(.+?)\}\}/g,
			escape: /\{\{-(.+?)\}\}/g
		};

		let dom;
		dom = this.options.dom;

		this.$showMoreButton = this.getEl(dom.showMore);
		this.$aside = $(dom.aside);
		this.$results = this.$el.find(this.options.dom.searchListResults);
		this.$resultsCount = this.$el.find(this.options.dom.listCount);
		this.$searchItemTmpl = _.template(_.unescape($('#searchItemTmpl').html().trim()), mustacheStyleSyntax);
		this.$searchQueryInput = this.$el.find(this.options.dom.searchQueryField).find('input');

		this.currentPage = 1;
		this.params = this.$el.data('params');

		// количество результатов на странице
		this.showCount = this.params.count || 5;
		this.source = this.params.source;

		this.$showMoreButton.on('click', e => { this.showMore(e); });
		this.$aside.on('click', '.aside__nav', e => { this.changeSection(e); });
		this.$aside.on('click', '.aside__link', e => { this.changeSection(e); });

		return this;
	}

	getEl(element) {
		return this.$el.find(element);
	}

	changeSection() {
		this.currentPage = 1;

		this.$results.html('');

		this.buildPage();
	}


	buildPage() {
		const filters = this.compileFilters();

		querySearch(this.source, filters)
			.then(this.renderResults.bind(this))
			.catch(this.renderResults.bind(this));
	}

	renderResults(data) {
		let content = '';
		this.$resultsCount.text(data.count);


		if (!data.items || !data.items.length) {
			data.items = [];
		}

		data.items.forEach( result => {
			content += [
				'<div class="search-list__item">',
				this.$searchItemTmpl({item: result}),
				'</div>'].join('');
		});

		this.$results.append(content);

		if (data.isLastPage) {
			this.$showMoreButton.hide();
		} else {
			this.$showMoreButton.show();
		}
	}

	compileFilters() {
		return {
			page: this.currentPage,
			type: this.getSelectedType(),
			count: this.showCount,
			q: this.$searchQueryInput.val()
		};
	}

	getSelectedType() {
		const $selectedNavItem = this.$aside.find('.' + this.options.classes.aside.nav.state.opened);
		const $selectedNavLink = this.$aside.find('.' + this.options.classes.aside.link.state.active);
		const navType = $selectedNavItem.find('.aside__nav').data('type');
		const linkType = $selectedNavLink.data('type');

		return linkType || navType;
	}

	showMore() {
		this.currentPage++;
		this.buildPage();
	}

	render() {
		if (this.$el.length) {
			this.getDom();
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/search-list/search-list.js
 **/